module.exports = "<div>\n  {{player?.name}}\n</div>\n<div>\n  Wining Bid: <span *ngIf=\"sharedService.settings?.showBidders\">{{sharedService.getUserById(sharedService.getWinningBid(player)?.teamId)?.displayName}} </span>{{sharedService.getWinningBid(player)?.value}}\n</div>\n<div *ngIf=\"sharedService.canUserBid(player, clock | async)\">\n  <input [(ngModel)]=\"newBidValue\">\n  <button mat-raised-button  (click)=\"newBid()\">Bid</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/player/player.component.html
// module id = ./src/app/components/player/player.component.html
// module chunks = main